import React, { useState } from 'react';
import { FaLock } from 'react-icons/fa';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-java';
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/mode-c_cpp';
import 'ace-builds/src-noconflict/mode-php';
import 'ace-builds/src-noconflict/theme-cobalt';
import 'ace-builds/webpack-resolver';
import './ChallengeDetail.css';
import { BiArrowBack } from "react-icons/bi";


const ChallengeDetail = ({ task, onClose }) => {
  const [activeTab, setActiveTab] = useState('solution');
  const [locked, setLocked] = useState(true);

  return (
    <div className="challenge-detail-container">
      {/* Challenge Details Card */}
      <div className="challenge-detail-card">
      <button className="back" onClick={onClose}>
    <BiArrowBack className="back-icon" /> Back to Challenges
  </button>
      <h3 className="card-title">Challenge: {task.title}</h3>
        <p><strong>Difficulty:</strong> {task.difficulty}</p>
        <p><strong>Description:</strong> {task.description}</p>
        <h4>Test Cases:</h4>
        <ul>
          {task.testCases.map((testCase, index) => (
            <li key={index}>{testCase}</li>
          ))}
        </ul>
        <p><strong>Remarks:</strong> {task.remarks}</p>
      </div>

      {/* Solution and Explanation Card */}
      <div className="solution-explanation-card">
        <div className="tab-buttons">
          <button
            className={activeTab === 'solution' ? 'active-tab' : ''}
            onClick={() => setActiveTab('solution')}
          >
            Solution
          </button>
          <button
            className={activeTab === 'explanation' ? 'active-tab' : ''}
            onClick={() => setActiveTab('explanation')}
          >
            Explanation
          </button>
        </div>

        {/* Lock Icon Overlay */}
        {locked && (
          <div className="lock-overlay" onClick={() => setLocked(false)}>
            <FaLock className="lock-icon" />
            <p>Click to Unlock</p>
          </div>
        )}

        {/* Conditionally render Solution or Explanation with blur if locked */}
        <div className={`tab-content ${locked ? 'blurred-content' : ''}`}>
          {activeTab === 'solution' ? (
            <div className="solution-content">
              <h4>Solution:</h4>
              <AceEditor
                 mode="javascript" // Set the mode dynamically
                theme="cobalt"
                name="solutionCode"
                value={task.solution}
                fontSize={12}
                width="100%"
                height="400px"
                readOnly={true}
                setOptions={{
                  enableBasicAutocompletion: true,
                  enableLiveAutocompletion: true,
                  enableSnippets: true,
                  showLineNumbers: true,
                  tabSize: 2,
                  useWorker: false,
                }}
              />
            </div>
          ) : (
            <div className="explanation-content">
              <h4>Explanation:</h4>
              <p>{task.explanation}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChallengeDetail;
